import CryptoJS from "crypto-js";
import { getUserFromStorage } from "./auth";

const FINANCIAL_FIELDS = [
  "montant",
  "prime_ttc",
  "prime_nette",
  "taxes",
  "commissions",
  "montant_propose",
  "montant_a_payer",
  "montant_paiement",
  "indemnite",
  "new_prime_nette",
  "prime_rc",
  "prime_facultative",
  "montant_frais_gestion_pool",
];

const FINANCIAL_ROUTES = [
  "/gestion-production/payments",
  "/gestion-production/polices",
  "/gestion-production/souscriptions",
  "/gestion-production/avenants",
  "/sinistres/reglement/propositions",
  "/gestion-production/bills",
];

const extractFinancialData = (data) => {
  if (!data || typeof data !== "object") return {};

  const financial = {};
  
  const extractFromObject = (obj, prefix = "") => {
    for (const key of Object.keys(obj)) {
      const value = obj[key];
      
      if (FINANCIAL_FIELDS.includes(key) && value !== undefined && value !== null) {
        financial[prefix ? `${prefix}.${key}` : key] = Number(value);
      }
      
      if (value && typeof value === "object" && !Array.isArray(value)) {
        extractFromObject(value, prefix ? `${prefix}.${key}` : key);
      }
    }
  };

  extractFromObject(data);
  return financial;
};

const sortObject = (obj) => {
  const sorted = {};
  Object.keys(obj).sort().forEach(key => {
    sorted[key] = obj[key];
  });
  return sorted;
};

const generateSignature = (data, userId, timestamp, secret) => {
  const financialData = sortObject(extractFinancialData(data));
  const payload = {
    data: financialData,
    userId: Number(userId),
    timestamp: String(timestamp),
  };
  return CryptoJS.HmacSHA256(JSON.stringify(payload), secret).toString();
};

export const getIntegrityHeaders = async (data) => {
  try {
    const userData = getUserFromStorage();
    const userId = userData?.user?.idusers;
    
    if (!userId) {
      return {};
    }

    const financialData = extractFinancialData(data);
    
    if (Object.keys(financialData).length === 0) {
      return {};
    }

    const timestamp = Date.now().toString();
    const secret = process.env.REACT_APP_INTEGRITY_SECRET || "default-integrity-secret";
    const signature = generateSignature(data, userId, timestamp, secret);

    return {
      "x-integrity-signature": signature,
      "x-integrity-timestamp": timestamp,
    };
  } catch (error) {
    console.error("[Integrity] Erreur génération signature:", error);
    return {};
  }
};

export const isFinancialRoute = (url) => {
  if (!url) return false;
  return FINANCIAL_ROUTES.some((route) => url.includes(route));
};

export const shouldSignRequest = (method, url, data) => {
  const isWriteMethod = ["POST", "PUT", "PATCH"].includes(method?.toUpperCase());
  
  if (!isWriteMethod) return false;
  
  if (!isFinancialRoute(url)) return false;
  
  const financialData = extractFinancialData(data);
  return Object.keys(financialData).length > 0;
};

export { FINANCIAL_FIELDS, FINANCIAL_ROUTES, extractFinancialData };
